<div *ngIf="hostname === 'zen-test.conmet.it'">
	
	<div style="position: sticky; top: 0; background-color: red; color: white; text-align: center; padding: 2px; z-index: 1000;"></div>
		
</div>
<app-loader></app-loader>
<router-outlet></router-outlet>

